export const OUTLOOK365 = 'o365';